const isDd = (string = "") => {
  if (!string) return false
  return string && string.toLowerCase().indexOf("dedicated desk") > -1
}

export default isDd
